/*
 * Public API Surface of principal-dasboard-lib
 */

export * from './lib/principal-dasboard-lib.service';
export * from './lib/principal-dasboard-lib.component';
export * from './lib/principal-dasboard-lib.module';
export * from 'angular-google-charts';
